/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_Forms_AcInputs */

const en_pc_cmp_r_forms_ac = /** @type {(inputs: Pc_Cmp_R_Forms_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AcroForms and XFA`)
};

const zh_pc_cmp_r_forms_ac = /** @type {(inputs: Pc_Cmp_R_Forms_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持 AcroForm 与 XFA`)
};

/**
* | output |
* | --- |
* | "AcroForms and XFA" |
*
* @param {Pc_Cmp_R_Forms_AcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_forms_ac = /** @type {((inputs?: Pc_Cmp_R_Forms_AcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_Forms_AcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_forms_ac(inputs)
	return zh_pc_cmp_r_forms_ac(inputs)
});
export { pc_cmp_r_forms_ac as "pc.cmp.r.forms.ac" }